module.exports = __webpack_public_path__ + "static/media/notification.5959cf50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notification.svg
// module id = 2378
// module chunks = 0